export const NULL_TYPE_NAME = 'Missing Type Name';
